import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import DealsCampaignSection from "@/components/DealsCampaignSection";

// Lazy load below-the-fold components to reduce initial bundle size
const PrivilegeCard = lazy(() => import("@/components/PrivilegeCard"));
const SpecialOfferSection = lazy(() => import("@/components/SpecialOfferSection"));
const CustomerClickSection = lazy(() => import("@/components/CustomerClickSection"));
const AboutSection = lazy(() => import("@/components/AboutSection"));
const MenuPreview = lazy(() => import("@/components/MenuPreview"));
const HomeContentSection = lazy(() => import("@/components/HomeContentSection"));
const DeliveryBanner = lazy(() => import("@/components/DeliveryBanner"));
const Footer = lazy(() => import("@/components/Footer"));
const AIChatbot = lazy(() => import("@/components/AIChatbot"));
const Index = () => {
  return (
    <>
      <Helmet>
        <title>Sizzlers Restaurant Jhelum | BBQ, Steaks & Desi Delights</title>
        <meta
          name="description"
          content="Experience premium BBQ, steaks, and desi delights at Sizzlers Restaurant Jhelum. Located on Main GT Road, Jhelum Cantt. Book your table today!"
        />
        <meta
          name="keywords"
          content="Sizzlers Restaurant Jhelum, best restaurant in Jhelum, BBQ in Jhelum, steak in Jhelum, family restaurant Jhelum Cantt, Main GT Road Jhelum restaurant"
        />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://sizzelrsjhelum.lovable.app/" />
        <meta property="og:locale" content="en_PK" />
        <meta property="og:site_name" content="Sizzlers Restaurant Jhelum" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Restaurant",
            name: "Sizzlers Restaurant Jhelum",
            url: "https://sizzelrsjhelum.lovable.app/",
            telephone: "0330-3628777",
            servesCuisine: ["BBQ", "Steak", "Pakistani", "Chinese", "Desserts"],
            priceRange: "$$",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Main GT Road",
              addressLocality: "Jhelum Cantt",
              addressRegion: "Punjab",
              addressCountry: "PK",
            },
            areaServed: ["Jhelum", "Jhelum Cantt"],
            hasMap: "https://www.google.com/maps/dir/?api=1&destination=32.9385,73.7285&destination_place_id=ChIJGZupmcoZGjkRypuLwEsPjFs",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Where is Sizzlers Restaurant located in Jhelum?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Sizzlers Restaurant is located on Main GT Road in Jhelum Cantt, beside Attock Petroleum and close to Chawani Chowk.",
                },
              },
              {
                "@type": "Question",
                name: "What are Sizzlers Restaurant timings?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We are open every day from 11:00 AM to 11:30 PM, including weekends and public holidays.",
                },
              },
              {
                "@type": "Question",
                name: "Does Sizzlers offer home delivery in Jhelum?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, home delivery is available within Jhelum city. Order from our website or via WhatsApp on 0330-3628777.",
                },
              },
              {
                "@type": "Question",
                name: "Can I reserve a table for a family dinner or birthday?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Book a table from our reservations page or call 0330-3628777. Group bookings and birthday celebrations are welcome.",
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <main>
        <Navbar />
        <Hero />
        <DealsCampaignSection />
        <Suspense fallback={null}>
          <PrivilegeCard />
          <SpecialOfferSection />
          <CustomerClickSection />
          <AboutSection />
          <MenuPreview />
          <HomeContentSection />
          <DeliveryBanner />
          <Footer />
          <AIChatbot />
        </Suspense>
      </main>
    </>
  );
};

export default Index;
